import React from 'react';
import InfiniteScroll from '../../../builderPackage/components/infiniteScroll/infiniteScroll';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { dateFormate } from '../../../utils/utils';
import { ExpandLess } from '@mui/icons-material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ContractSaleOrderPagingAPI } from '../../contractSaleOrder/services/apiCall';
import { ContractSaleOrderKeys } from '../../contractSaleOrder/services/entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useNavigate } from 'react-router-dom';
var Jci_returnMobileView = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$ContractSaleOrd, _crud$ContractSaleOrd2;
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var crud = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; });
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var hasMore = !crud[ContractSaleOrderKeys.Paging] || ((_crud$ContractSaleOrd = crud[ContractSaleOrderKeys.Paging]) === null || _crud$ContractSaleOrd === void 0 || (_crud$ContractSaleOrd = _crud$ContractSaleOrd.data) === null || _crud$ContractSaleOrd === void 0 ? void 0 : _crud$ContractSaleOrd.length) < ((_crud$ContractSaleOrd2 = crud[ContractSaleOrderKeys.Paging]) === null || _crud$ContractSaleOrd2 === void 0 ? void 0 : _crud$ContractSaleOrd2.TotalCount);
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'center',
                    spacing: 0,
                    // bgcolor:'red',
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: true,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "OrderNumber",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "OrderDate",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.OrderDate ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.OrderDate)) : '-'; },
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'secondary.900'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal',
                                    color: 'secondary.500'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: true,
                            justifyContent: 'flex-end',
                            alignItems: 'baseline',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'StatusName',
                                    variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'info',
                                    sx: {
                                        borderRadius: '6px'
                                    }
                                }
                                // {
                                //     type: FormItemTypes.IconButton,
                                //     name: 'Header',
                                //     label: '',
                                //     children: <MoreVert />,
                                //     columnSize: 0,
                                //     onClick: async (e) => {
                                //         const res = await dispatch(showSurface({
                                //             type: 'Menu',
                                //             Component: ActionMenuList,
                                //             containerProps: {
                                //                 anchorEl: e?.target as any,
                                //                 anchorOrigin: { vertical: 'center', horizontal: 'right' },
                                //                 transformOrigin: { vertical: 'top', horizontal: 'right' },
                                //             },
                                //             componentProps: {
                                //                 items: [
                                //                     {
                                //                         id: 'GenerateInvoice',
                                //                         children: ["Generate invoice"]
                                //                     },
                                //                     {
                                //                         id: 'EditOrder',
                                //                         children: ["Edit order"]
                                //                     },
                                //                     {
                                //                         id: 'CancelOrder',
                                //                         children: ["Cancel order"]
                                //                     },
                                //                     {
                                //                         id: 'ShareOrder',
                                //                         children: ["Share order"]
                                //                     },
                                //                     {
                                //                         id: 'PrintOrder',
                                //                         children: ["Print order"]
                                //                     },
                                //                 ]
                                //             } as any,
                                //         }))
                                //         // if (res?.payload === 'CancelOrder') {
                                //         //     console.log("res?.payload", res?.payload)
                                //         //     await dispatch(showSurface({
                                //         //         type: 'Drawer',
                                //         //         Component: CancelOrderPopup,
                                //         //         containerProps: {
                                //         //             anchor: 'bottom',
                                //         //         }
                                //         //     }))
                                //         // }
                                //     }
                                // }
                            ]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    containerProps: {
                        spacing: 0
                    },
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 1,
                        p: 1.5,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    setFieldProps: function (state, currValue, field) {
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'JobcardNo:',
                                    label: 'Job card No:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'InvoiceNo',
                                    label: 'Invoice No:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ScheduledDate',
                                    label: 'Posting type:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ServiceType',
                                    label: 'Service type:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'ServiceAdvisor',
                                    label: 'Invoice date:',
                                    fontSize: 'sm',
                                    fontWeight: 'medium',
                                    columnSize: 12,
                                    labelTypographyProps: {
                                        mb: 0
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: 'space-between'
                                    },
                                    valueGetter: function (formValues, field) {
                                        var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                        if (currValue)
                                            return currValue;
                                        else
                                            return '-';
                                    }
                                }]
                        };
                    },
                    elements: []
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: true,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: '',
                                    value: 'Return Invoice',
                                    variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'info',
                                    sx: {
                                        borderRadius: '6px'
                                    },
                                    onClick: function () {
                                        navigate('/newJobCardInvoicesReturn');
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Close', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: ContractSaleOrderPagingAPI,
        apiKey: ContractSaleOrderKeys.Paging,
        apiRequest: {
            Status: ['Open'],
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId,
            IdentityId: "all"
        },
        elements: formData,
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2,
            p: 2
        },
        gridItemProps: {
            xs: 12
        }
    }));
};
export default Jci_returnMobileView;
